export enum ShipmentStatus {
  ACQUIRED = 'Acquired',
  DRIVER_REACHED_BRANCH = 'DriverReachedBranch',
  PICKED_UP = 'PickedUp',
  DELIVERING = 'Delivering',
  AT_DESTINATION = 'AtDestination',
  COMPLETED = 'Completed',
  REJECTED = 'Rejected',
  CANCELED = 'Canceled'
}
